import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrencyCode } from '@core/dto/CurrencyCode';
interface TopUpBalanceDto {
  currencyCode: CurrencyCode;
  amount: number;
}
@Injectable()
export class TopUpService {
  private readonly httpReqOptions = { withCredentials: true };

  constructor(private httpClient: HttpClient) {}

  public getTopUpBalance(): Observable<TopUpBalanceDto> {
    const url = `${environment.apiUrl}/refund/refundAccount/balance`;
    return this.httpClient.get<TopUpBalanceDto>(url, this.httpReqOptions);
  }
}
